export default {"src":"/login-app/[GIT_HASH]/_next/static/media/file_markdown.8d3f2ea5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};